import { createAsyncThunk } from "@reduxjs/toolkit";

import { makeRequest } from "../../utilities/api";
// import { createFormData } from "../../utilities";

export const getCompanies = createAsyncThunk("company/getAll", async (values, { rejectWithValue }) => makeRequest("/companies", "GET", values, rejectWithValue));

export const getCompany = createAsyncThunk("company/get", async (values, { rejectWithValue }) => makeRequest(`/companies/${values?.companyId}`, "GET", values, rejectWithValue));

// export const patchCompany = createAsyncThunk("company/patch", async (values, { rejectWithValue }) => {
//   const data = {};
//   Object.keys(values).forEach((key) => {
//     if ((Array.isArray(values[key]) && values[key].length === 0) || (key.includes("companyLogo") && !(values[key] instanceof File))) {
//       return;
//     }
//     data[key] = values[key];
//   });
//   return makeRequest(`/companies/${values?.id}`, "PATCH", createFormData(data), rejectWithValue);
// });

export const patchCompany = createAsyncThunk("company/patch", async (values, { rejectWithValue }) => {
  const formData = new FormData();

  Object.keys(values).forEach((key) => {
    const value = values[key];

    // skip empty arrays
    if (Array.isArray(value) && value.length === 0) return;

    // skip invalid logo
    if (key.includes("companyLogo") && !(value instanceof File)) return;

    // ✅ handle contacts
    if (key === "contacts" && Array.isArray(value)) {
      value.forEach((contact, index) => {
        Object.keys(contact).forEach((field) => {
          if (field === "index") return;
          if (contact[field] !== undefined) {
            formData.append(`contacts[${index}].${field}`, contact[field]);
          }
        });
      });
      return;
    }

    // ✅ handle address (ONLY address is flattened)
    if (key === "address" && typeof value === "object" && value !== null) {
      Object.keys(value).forEach((addressKey) => {
        if (value[addressKey] !== undefined) {
          formData.append(`address.${addressKey}`, value[addressKey]);
        }
      });
      return;
    }

    // ✅ handle address (ONLY address is flattened)
    if (key === "additionalAddress" && typeof value === "object" && value !== null) {
      Object.keys(value).forEach((addressKey) => {
        if (value[addressKey] !== undefined) {
          formData.append(`additionalAddress.${addressKey}`, value[addressKey]);
        }
      });
      return;
    }

    // normal fields
    formData.append(key, value);
  });

  return makeRequest(`/companies/${values?.id}`, "PATCH", formData, rejectWithValue);
});

export const getFilteredCompanies = createAsyncThunk("users/getFilteredCompanies", async (values, { rejectWithValue }) => makeRequest("/companies/filter", "POST", values, rejectWithValue));
